import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';

/**
 * Layout wrapper for `vh-chip`s. Emits `cleared` when the user clicks
 * the "Clear all" button.
 */
@Component({
  selector: 'vh-chip-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vh-chip-group__chips" role="list">
      <ng-content />
    </div>
    @if (showClear()) {
      <button type="button" class="vh-chip-group__clear" (click)="cleared.emit()">
        {{ clearLabel() }}
      </button>
    }
  `,
  styleUrl: './chip-group.component.scss',
})
export class VhChipGroupComponent {
  readonly showClear = input(false, { transform: booleanAttribute });
  readonly clearLabel = input<string>('Clear all');

  readonly cleared = output<void>();
}
